export const LIST_REQUIRED_STATUSES = [
  "Pre Application",
  // "Applied"
];



// WEBPACK FOOTER //
// ./src/constants/required-values.js